const Langs = [
    { key : "fr-fr"},
    { key : "en-gb"}
]

export default Langs